import type { CrmBoardSegment } from '@upme/contracts';

export const CRM_SEGMENT_LABEL_RU: Record<CrmBoardSegment, string> = {
  all: 'Все сделки',
  organizers: 'Организаторы',
  participants: 'Участники',
  warm: 'Новички / в обработке',
};

export const CRM_SEGMENT_ORDER: readonly CrmBoardSegment[] = ['all', 'organizers', 'participants', 'warm'];
